import { createContext } from "react";

const blitzSessionContext = createContext();

export default blitzSessionContext;